const a = "56px", r = {
  blue: "var(--plac-icon-fill-active)",
  gray: "var(--plac-icon-default)",
  outline: "var(--plac-icon-default)",
  disabled: "var(--plac-primary-disabled)",
  white: "var(--plac-primary-white)",
  "primary-brand": "var(--plac-primary-brand)",
  "default-gray": "var(--plac-icon-outline)"
};
export {
  a as DEFAULT_METRIC_ICON_SIZE,
  r as ICONS_COLOR_MAPPING
};
//# sourceMappingURL=index.es2447.js.map
